"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
/**
 * update the status of ORDER ITEM
 * Can only be update  when the the item status is in CREATED OR ON_HOLD status
 * @param event of type OrderPayment
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = prevState;
    order.orderItems = order.orderItems || [];
    //Remove splitted combo items for course
    const items = (order.orderItems || []).filter(i => { var _a; return !((_a = i.parentCombo) === null || _a === void 0 ? void 0 : _a.id); });
    const comboItems = (0, utils_1.getComboItems)(items);
    event.orderItemsToFire.forEach(fireItem => {
        const orderItem = [...items, ...comboItems].find(item => item.id === fireItem.id);
        if (!orderItem ||
            ![domain_1.OrderItemStatus.CREATED, domain_1.OrderItemStatus.ON_HOLD].includes(orderItem.status))
            return;
        orderItem.status = fireItem.status
            ? domain_1.OrderItemStatus.CREATED
            : domain_1.OrderItemStatus.ON_HOLD;
    });
    order.orderItems = (0, utils_1.mergeIdenticalOrderItems)(order.orderItems);
    return order;
}
exports.default = default_1;
//# sourceMappingURL=fireOrderItems.js.map